import { executeRequest, JFSRequest } from '@jfs/network'
import { formatDate, isSuccessResponse } from '../utils'
import { APIEndPoints } from './APIEndPoints'
import { getHeaders, getUrl, sitConfig } from './config'

const responseParser = (response: any) => {
  const data = isSuccessResponse(response)

  return data?.map((item: any) => {
    const filetype = () => {
      // const saved = item?.object?.savedFileName
      const originalArr = item?.object?.originalFileName?.split('.')
      return originalArr?.[originalArr.length - 1] ?? 'xls'
    }
    return {
      id: item?.id,
      key: item?.key ?? '',
      type: item?.type ?? '',
      className: item?.className ?? '',
      username: item?.username ?? '',
      approvalType: item?.approvalType ?? '',
      approvalStatus: item?.approvalStatus ?? '',
      data: {
        type: 'FileUpload',
        // id: item?.object?.id,
        // ruleName: item?.object?.ruleName,
        // payeeType: item?.object?.payeeType,
        // payeeUserId: item?.object?.payeeUserId,
        // payeeVpa: item?.object?.payeeVpa,
        // payerBankId: item?.object?.payerBankId,
        // binList: item?.object?.binList,
        // binRange: item?.object?.binRange,
        // cardType: '' + item?.object?.cardType,
        // scheme: '' + item?.object?.scheme,
        // amount: item?.object?.amount,
        // transactionInitiatingEntityId: '' + item?.object?.transactionInitiatingEntityId,
        // transactionApplication: item?.object?.transactionApplication,
        // txntype: '' + item?.object?.txntype,
        // instrumentType: '' + item?.object?.instrumentType,
        // mode: item?.object?.mode,
        // activationGroup: item?.object?.activationGroup,
        // priority: item?.object?.priority,
        // processor: item?.object?.processor,
        // isActive: item?.object?.isActive,
        // isAssigned: item?.object?.isAssigned,
      },
      fileUploadData: {
        id: item?.id,
        fileName: item?.object?.savedFileName,
        link: item?.object?.filePath,
        createdDate: formatDate(item?.createdDate),
        fileType: filetype(),
      },
    }
  })
}

const getFileRoutingApprovals = (elevated: boolean, tokens: any, fileType: any) => {
  const request: JFSRequest<{}> = {
    apiPath: getUrl(APIEndPoints.routingFileApproval),
    method: 'GET',
    cache: false,
    config: sitConfig(tokens),
    headers: getHeaders(),
    body: {
      elevated,
      fileType
    },
  }

  return executeRequest(request)
    .then(responseParser)
    .catch((error) => {
      throw error
    })
}

export { getFileRoutingApprovals }
